import { icons } from '../assets/icons';

export class FeaturesComponent {
  public render(): string {
    const features = [
      {
        title: 'Multi‑Column Layout',
        description: 'View Home, Notifications, Mentions, Direct Messages, Local, and Federated timelines simultaneously side-by-side with automatic responsive collapsing.',
        icon: icons.layers('w-5 h-5 text-matrix-400')
      },
      {
        title: 'High-Fidelity Media (Sixel/TGP/ANSI)',
        description: 'Inline image previews right inside your terminal with automated protocol negotiation for Sixel, Kitty/Ghostty/WezTerm TGP, and ANSI blocks.',
        icon: icons.image('w-5 h-5 text-cyber-400')
      },
      {
        title: 'Persistent SQLite Cache',
        description: 'SQLite-backed local caching keeps timeline scrolling silky-smooth and provides offline reading resilience during network hiccups.',
        icon: icons.server('w-5 h-5 text-matrix-400')
      },
      {
        title: 'Rich Composer & Polls',
        description: 'Full composer with real-time character counting, Content Warnings (CW), interactive poll builder, tab autocomplete, and multi-language tagging.',
        icon: icons.edit('w-5 h-5 text-cyber-400')
      },
      {
        title: 'Vim-Like Navigation',
        description: 'Pure keyboard efficiency: like, boost, reply, inspect threads, extract URLs, and jump to top (g) with customizable keybindings in keymap.json.',
        icon: icons.keyboard('w-5 h-5 text-matrix-400')
      },
      {
        title: 'Multi-Profile & Sandboxed Configs',
        description: 'Seamlessly switch between multiple Mastodon accounts. Each profile maintains isolated credentials, configs, keymaps, and cache databases.',
        icon: icons.shield('w-5 h-5 text-cyber-400')
      },
      {
        title: 'Server-Side Filter Manager',
        description: 'Create, modify, and delete server-side Mastodon filters directly in the TUI with context matching, expiration dates, and keyword lists.',
        icon: icons.badgeCheck('w-5 h-5 text-matrix-400')
      },
      {
        title: 'Themeable & Custom TCSS',
        description: 'Multiple built-in themes (Retro Green, Dark Slate, Light) plus custom Textual CSS override support via ~/.config/mastui/custom.tcss.',
        icon: icons.tv('w-5 h-5 text-cyber-400')
      },
      {
        title: 'Debug Log Stream Viewer (F12)',
        description: 'Real-time integrated debug console and logging inspector available at the touch of a button when launching with the --debug flag.',
        icon: icons.terminal('w-5 h-5 text-matrix-400')
      }
    ];

    return `
      <section id="features" class="py-16 md:py-24 border-t border-terminal-border bg-terminal-bgDark/40">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <div class="text-center max-w-3xl mx-auto space-y-3 mb-14">
            <div class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-mono font-semibold bg-matrix-950/80 text-matrix-400 border border-matrix-800 shadow-glow-sm">
              <span>// ARCHITECTURE & CAPABILITIES</span>
            </div>
            <h2 class="text-2xl sm:text-4xl font-extrabold text-white tracking-tight">
              Engineered for Terminal Power Users
            </h2>
            <p class="text-sm sm:text-base text-terminal-muted font-mono">
              Everything you expect from modern Mastodon, crafted without GUI overhead or electron bloat.
            </p>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            ${features.map(f => `
              <div class="p-6 rounded-2xl bg-terminal-card border border-terminal-border hover:border-matrix-500/60 hover:shadow-glow transition-all duration-300 group flex flex-col justify-between">
                <div class="space-y-3">
                  <div class="w-10 h-10 rounded-xl bg-terminal-bgDark border border-terminal-border flex items-center justify-center group-hover:scale-105 transition-transform">
                    ${f.icon}
                  </div>
                  <h3 class="text-base font-bold text-matrix-400 group-hover:text-matrix-300 font-mono flex items-center gap-2">
                    <span>${f.title}</span>
                  </h3>
                  <p class="text-xs text-terminal-fg/90 leading-relaxed font-mono">
                    ${f.description}
                  </p>
                </div>
              </div>
            `).join('')}
          </div>

        </div>
      </section>
    `;
  }
}
